import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import config from "../../config";
import { selectLoginRedirect } from "../../redux/loginRedirectSlice";

const isAllowedRedirect = (url) => {
  if (typeof url !== 'string') {
    return false;
  }
  const isAdminApiUrl = url.startsWith(`${config.adminApiOrigin}/`);
  const isAdminPortalWebsiteUrl = url.startsWith(`${config.adminPortalWebsiteOrigin}/`);
  const isAllowed = isAdminApiUrl || isAdminPortalWebsiteUrl;
  return isAllowed;
}

export function Redirect() {
  const { url, message } = useSelector(selectLoginRedirect);
  const history = useHistory();

  useEffect(async () => {
    if (isAllowedRedirect(url)) {
      window.location.replace(url);
    } else {
      console.error(`${url} is not an allowed redirect url`);
      history.replace(config.loginRoot);
    }
  },  [url])

  return (
    <React.Fragment>
      <h4 className="form-title">{message || "Please wait"}</h4>
    </React.Fragment>
  );
}